<script setup lang="ts">
import vuIcon from '@ds/vuekit/src/components/vu-icon.vue';
import { HomepageWhyJoinAsServiceProvider } from '~/models/homepage';

const props = defineProps<{
  feature: HomepageWhyJoinAsServiceProvider;
}>();
</script>
<template>
  <div class="flex flex-row grid-gap-10px service-provider-feature">
    <div class="icon-container">
      <vu-icon :icon="props.feature.icon" color="blue" />
    </div>
    <div class="flex flex-column">
      <div class="subtitle text-content text--uppercase">
        {{ props.feature.name }}
      </div>
      <div class="feature-content">
        {{ props.feature.content }}
      </div>
    </div>
  </div>
</template>
<style lang="css" scoped>
.feature-content {
  color: var(--grey-6);
}

.icon-container {
  width: 40px;
  height: 40px;
}

.icon-container .fonticon {
  font-size: 30px;
  color: var(--blue-2);
}
</style>
